module.exports = __webpack_public_path__ + "img/DHP_Logo_no_text.903fa839.png";